// 24/10/2026 : Paramètres > Projets — liste des projets du planning (SOPlanning), ajout et modification
// (libellé, couleur). Aucune suppression ici : supprimer un projet dans SOPlanning touche ses tâches.
import React from "react";
import { getSoPlanningProjects } from "../../store/external/soplanning";
import { createProject, makeProjectId, nextProjectColor } from "../Request/Tab/planningExtras";

const fixEnc = (t) => {
  t = String(t == null ? "" : t);
  if (/Ã.|Â/.test(t)) { try { return decodeURIComponent(escape(t)); } catch (e) { /* tel quel */ } }
  return t;
};
const hex = (c) => "#" + (/^[0-9a-fA-F]{6}$/.test(String(c || "")) ? c : "dddddd");
const errText = (e) => {
  const d = e && e.response && e.response.data;
  return (d && (d.message || d.error)) || (e && e.message) || "erreur";
};

export default class PlanningProjects extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: true, error: null, projects: [], filter: "", name: "", code: "", codeTouched: false, color: "#1f6fd1", saving: false, msg: null, edit: null };
  }

  componentDidMount() { this.load(); }

  load() {
    this.setState({ loading: true, error: null });
    getSoPlanningProjects().then((r) => {
      const list = (r && r.data && r.data.data) || [];
      const projects = list.map((p) => Object.assign({}, p, { name: fixEnc(p.name) }))
        .sort((a, b) => a.name.localeCompare(b.name, "fr"));
      this.setState({ loading: false, projects, color: this.state.name ? this.state.color : "#" + nextProjectColor(projects) });
    }).catch((e) => this.setState({ loading: false, error: "Planning indisponible : " + errText(e) }));
  }

  onName = (e) => {
    const name = e.target.value;
    const st = { name, msg: null };
    if (!this.state.codeTouched) st.code = name.trim() ? makeProjectId(name, this.state.projects.map((p) => p.id)) : "";
    this.setState(st);
  };

  add = (e) => {
    e.preventDefault();
    const { name, code, color, projects } = this.state;
    const n = name.trim();
    if (!n) return;
    if (projects.some((p) => p.name.trim().toLowerCase() === n.toLowerCase())) {
      this.setState({ msg: { ok: false, t: "Un projet « " + n + " » existe déjà." } });
      return;
    }
    if (projects.some((p) => String(p.id).toLowerCase() === code.toLowerCase())) {
      this.setState({ msg: { ok: false, t: "Le code " + code + " est déjà pris." } });
      return;
    }
    this.setState({ saving: true, msg: null });
    createProject({ id: code, name: n, color: color.replace("#", "") }).then(() => {
      this.setState({ saving: false, name: "", code: "", codeTouched: false, msg: { ok: true, t: "Projet « " + n + " » ajouté au planning (code " + code + ")." } });
      this.load();
    }).catch((err) => this.setState({ saving: false, msg: { ok: false, t: "Ajout refusé : " + errText(err) } }));
  };

  saveEdit = () => {
    const { edit, projects } = this.state;
    const p = projects.find((x) => x.id === edit.id);
    const n = edit.name.trim();
    if (!p || !n) return;
    this.setState({ saving: true, msg: null });
    createProject(Object.assign({}, p, { name: n, color: edit.color.replace("#", "") })).then(() => {
      this.setState({ saving: false, edit: null, msg: { ok: true, t: "Projet « " + n + " » enregistré." } });
      this.load();
    }).catch((err) => this.setState({ saving: false, msg: { ok: false, t: "Modification refusée : " + errText(err) } }));
  };

  render() {
    const { loading, error, projects, filter, name, code, color, saving, msg, edit } = this.state;
    const f = filter.trim().toLowerCase();
    const shown = projects.filter((p) => !f || p.name.toLowerCase().indexOf(f) >= 0 || String(p.id).toLowerCase().indexOf(f) >= 0);
    return (
      <div style={{ padding: "12px 4px" }}>
        <p className="text-muted" style={{ marginBottom: 10 }}>
          Projets du planning (SOPlanning), proposés dans la liste « Projet » de l'onglet Planification et dans la PWA.
          Un projet ajouté ici est créé aussitôt dans le planning. Pas de suppression ici (elle toucherait les tâches du projet) : passer par SOPlanning si besoin.
        </p>
        <form className="form-inline" onSubmit={this.add} style={{ marginBottom: 12 }}>
          <div className="form-group" style={{ marginRight: 8 }}>
            <input className="form-control" placeholder="Libellé du projet (ex. Réparation fuite)" maxLength={50} style={{ width: 300 }}
              value={name} onChange={this.onName} disabled={saving} />
          </div>
          <div className="form-group" style={{ marginRight: 8 }}>
            <input className="form-control" placeholder="Code" maxLength={20} style={{ width: 150, fontFamily: "monospace" }} title="Code SOPlanning (lettres et chiffres), proposé d'après le libellé"
              value={code} onChange={(e) => this.setState({ code: e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ""), codeTouched: true })} disabled={saving} />
          </div>
          <div className="form-group" style={{ marginRight: 8 }}>
            <input type="color" value={color} onChange={(e) => this.setState({ color: e.target.value })} title="Couleur dans le planning"
              style={{ width: 44, height: 34, padding: 2, border: "1px solid #ccc", borderRadius: 4, verticalAlign: "middle" }} disabled={saving} />
          </div>
          <button type="submit" className="btn btn-primary" disabled={saving || !name.trim() || !code}>
            <span className="fa fa-plus" /> Ajouter le projet
          </button>
        </form>
        {msg ? <div className={"alert " + (msg.ok ? "alert-success" : "alert-danger")} style={{ padding: "8px 12px" }}>{msg.t}</div> : null}
        {error ? <div className="alert alert-danger" style={{ padding: "8px 12px" }}>{error}</div> : null}
        <div style={{ display: "flex", alignItems: "center", marginBottom: 6 }}>
          <input className="form-control input-sm" placeholder="Rechercher un projet…" style={{ width: 260 }} value={filter} onChange={(e) => this.setState({ filter: e.target.value })} />
          <span className="text-muted" style={{ marginLeft: 10 }}>{loading ? "Chargement…" : shown.length + " / " + projects.length + " projets"}</span>
          <button type="button" className="btn btn-default btn-sm" style={{ marginLeft: "auto" }} onClick={() => this.load()} title="Relire la liste">↻</button>
        </div>
        <table className="table table-condensed table-hover" style={{ background: "#fff" }}>
          <thead><tr><th style={{ width: 50 }}>Couleur</th><th style={{ width: 170 }}>Code</th><th>Libellé</th><th style={{ width: 170 }} /></tr></thead>
          <tbody>
            {shown.map((p) => edit && edit.id === p.id ? (
              <tr key={p.id}>
                <td><input type="color" value={edit.color} onChange={(e) => this.setState({ edit: Object.assign({}, edit, { color: e.target.value }) })} style={{ width: 36, height: 26, padding: 0, border: "none" }} /></td>
                <td style={{ fontFamily: "monospace" }}>{p.id}</td>
                <td><input className="form-control input-sm" maxLength={50} value={edit.name} onChange={(e) => this.setState({ edit: Object.assign({}, edit, { name: e.target.value }) })} /></td>
                <td style={{ whiteSpace: "nowrap" }}>
                  <button type="button" className="btn btn-primary btn-xs" disabled={saving || !edit.name.trim()} onClick={this.saveEdit}>Enregistrer</button>{" "}
                  <button type="button" className="btn btn-default btn-xs" onClick={() => this.setState({ edit: null })}>Annuler</button>
                </td>
              </tr>
            ) : (
              <tr key={p.id}>
                <td><span style={{ display: "inline-block", width: 26, height: 16, borderRadius: 3, border: "1px solid rgba(0,0,0,.2)", background: hex(p.color) }} /></td>
                <td style={{ fontFamily: "monospace" }}>{p.id}</td>
                <td>{p.name}</td>
                <td><button type="button" className="btn btn-default btn-xs" onClick={() => this.setState({ edit: { id: p.id, name: p.name, color: hex(p.color) }, msg: null })}><span className="fa fa-edit" /> Modifier</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Settings/PlanningProjects.js